module.exports = __webpack_public_path__ + "img/798916b.png";